document.addEventListener("page:loaded", () => {
  window.location.hostname === "127.0.0.1" &&
    console.log(
      "%c Page has loaded and theme assets are ready",
      "background: #222; color: #bada55"
    );
});

// Fix for hub color loading state issues
document.addEventListener("DOMContentLoaded", function () {
  // Wait for Alpine and the wheel builder to initialize
  setTimeout(function () {
    if (window.Alpine) {
      // Monitor for wheel builder form initialization
      const wheelBuilderObserver = new MutationObserver(function (mutations) {
        for (let mutation of mutations) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "x-data"
          ) {
            const builderForm = document.querySelector(
              '.wheelbuilder [x-data^="wheelBuilderForm"], .wheelbuilder [x-data^="hubBuilderForm"]'
            );
            if (builderForm) {
              fixHubColorLoading();
              break;
            }
          }
        }
      });

      // Observe the document body for wheel builder initialization
      wheelBuilderObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["x-data"],
      });

      // Check if wheel builder is already initialized
      const builderForm = document.querySelector(
        '.wheelbuilder [x-data^="wheelBuilderForm"], .wheelbuilder [x-data^="hubBuilderForm"]'
      );
      if (builderForm) {
        fixHubColorLoading();
      }
    }
  }, 100); // Reduced timeout for faster initialization

  // Function to fix hub color loading issues
  function fixHubColorLoading() {
    // Get Alpine component instance
    const builderForm = document.querySelector(
      '.wheelbuilder [x-data^="wheelBuilderForm"], .wheelbuilder [x-data^="hubBuilderForm"]'
    );
    if (!builderForm || !window.Alpine) return;

    // Monitor hub color section for visibility changes
    const hubColorSection = document.querySelector(
      '[data-option-group="hub_colour"]'
    );
    if (!hubColorSection) return;

    // Initial setup of loading indicators
    setupHubColorLoadingIndicators();

    // Create mutation observer for hub colors
    const hubColorObserver = new MutationObserver(function (mutations) {
      // Force update loading indicators when DOM changes
      updateHubColorLoadingState(true);
    });

    // Observe hub color section for changes
    hubColorObserver.observe(hubColorSection, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "disabled", "aria-disabled"],
    });

    // Setup initial loading indicators
    function setupHubColorLoadingIndicators() {
      const hubColorElements = document.querySelectorAll(
        '[data-option="hub_colour"]'
      );

      // Create loading indicators for each hub color option
      hubColorElements.forEach((element) => {
        if (!element.querySelector(".color-loading-indicator")) {
          const loadingIndicator = document.createElement("div");
          loadingIndicator.className = "color-loading-indicator";
          loadingIndicator.innerHTML =
            '<div class="spinner"></div><span>Loading...</span>';

          // Style the loading overlay - always show by default until we know state
          loadingIndicator.style.cssText =
            "position: absolute; top: 0; left: 0; right: 0; bottom: 0; " +
            "background: rgba(255,255,255,0.9); display: flex; flex-direction: column; " +
            "align-items: center; justify-content: center; z-index: 100; " +
            "border-radius: inherit; font-weight: bold; color: #333; font-size: 14px;";

          // Style the spinner
          const spinner = loadingIndicator.querySelector(".spinner");
          spinner.style.cssText =
            "width: 30px; height: 30px; border: 4px solid rgba(0,0,0,0.2); " +
            "border-top-color: #000; border-radius: 50%; " +
            "animation: spin 0.8s linear infinite; margin-bottom: 10px;";

          // Add animation for spinner if not already added
          if (!document.getElementById("spinnerAnimation")) {
            const style = document.createElement("style");
            style.id = "spinnerAnimation";
            style.textContent =
              "@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }";
            document.head.appendChild(style);
          }

          // Ensure parent has position relative
          element.style.position = "relative";
          element.style.overflow = "hidden";

          // Add loading indicator
          element.appendChild(loadingIndicator);
        }
      });

      // Add a group loading message at the top of the hub color section with Tailwind-style warning alert
      if (!hubColorSection.querySelector(".group-loading-message")) {
        const groupMessage = document.createElement("div");
        groupMessage.className = "group-loading-message";
        groupMessage.innerHTML =
          '<svg class="alert-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="24" height="24"><path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" /></svg><span>Loading hub color options...</span>';

        // Tailwind-style warning alert
        groupMessage.style.cssText =
          "display: flex; align-items: center; gap: 0.5rem; " +
          "background-color: #fef3c7; color: #92400e; " +
          "border-left: 4px solid #f59e0b; padding: 1rem; " +
          "margin-bottom: 1rem; border-radius: 0.25rem; " +
          "box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);";

        // Style for the alert icon
        const alertIcon = groupMessage.querySelector(".alert-icon");
        if (alertIcon) {
          alertIcon.style.cssText = "flex-shrink: 0; color: #f59e0b;";
        }

        hubColorSection.insertBefore(groupMessage, hubColorSection.firstChild);
      }

      // Force initial update of loading state with true to ensure visibility
      updateHubColorLoadingState(true);
    }

    function getWheelbuilderFormData() {
      const el = document.querySelector(
        '.wheelbuilder [x-data^="wheelBuilderForm"], .wheelbuilder [x-data^="hubBuilderForm"]'
      );
      if (!el || !window.Alpine) return null;
      try {
        return Alpine.$data(el);
      } catch (_) {
        return null;
      }
    }

    // Function to update hub color loading state
    function updateHubColorLoadingState(forceLoading = false) {
      const store =
        Alpine.store && typeof Alpine.store === "function"
          ? Alpine.store("wheelBuilderForm")
          : null;
      const formData = getWheelbuilderFormData();
      const src = store || formData;

      // We consider it loading if any of these conditions are true
      const isLoading =
        forceLoading ||
        (src &&
          (src.isFetchingProducts ||
            src.loading ||
            src.fetchingHubInventory ||
            !src.hasCompletedInventoryCheck)) ||
        hubColorSection.classList.contains("options-loading") ||
        document.querySelector(".product-loading-message")?.style.display !==
          "none";

      const hubColorElements = document.querySelectorAll(
        '[data-option="hub_colour"]'
      );
      const groupMessage = hubColorSection.querySelector(
        ".group-loading-message"
      );

      if (isLoading) {
        // Show loading state
        if (groupMessage) groupMessage.style.display = "flex";
        hubColorSection.classList.add("options-loading");

        hubColorElements.forEach((element) => {
          element.classList.add("loading");
          const loadingIndicator = element.querySelector(
            ".color-loading-indicator"
          );
          if (loadingIndicator) loadingIndicator.style.display = "flex";

          // Disable the element and its inputs
          element.setAttribute("aria-disabled", "true");
          const inputs = element.querySelectorAll("input, button, select");
          inputs.forEach((input) => {
            input.disabled = true;
            input.setAttribute("data-loading-disabled", "true");
          });
        });

        // Log loading state for debugging
        console.debug("Hub colors loading state activated");
      } else {
        // Hide loading state
        if (groupMessage) groupMessage.style.display = "none";
        hubColorSection.classList.remove("options-loading");

        hubColorElements.forEach((element) => {
          element.classList.remove("loading");
          const loadingIndicator = element.querySelector(
            ".color-loading-indicator"
          );
          if (loadingIndicator) loadingIndicator.style.display = "none";

          // Only enable inputs that should be enabled
          if (
            !element.classList.contains("disabled") &&
            !element.hasAttribute("disabled")
          ) {
            element.setAttribute("aria-disabled", "false");
            const inputs = element.querySelectorAll(
              '[data-loading-disabled="true"]'
            );
            inputs.forEach((input) => {
              input.disabled = false;
              input.removeAttribute("data-loading-disabled");
            });
          }
        });

        // Log end of loading state for debugging
        console.debug("Hub colors loading state deactivated");
      }
    }

    // Intercept Alpine data changes related to the wheel builder
    if (window.Alpine.store && window.Alpine.store("wheelBuilderForm")) {
      const store = window.Alpine.store("wheelBuilderForm");

      // Add custom properties for better tracking if they don't exist
      if (store.hubColorsLoading === undefined) {
        store.hubColorsLoading = true;
      }

      // Direct monitor for hub color-specific actions
      const originalSetCompletedInventoryCheck =
        store.hasCompletedInventoryCheck;
      Object.defineProperty(store, "hasCompletedInventoryCheck", {
        get() {
          return originalSetCompletedInventoryCheck;
        },
        set(value) {
          const oldValue = originalSetCompletedInventoryCheck;
          originalSetCompletedInventoryCheck = value;
          if (oldValue !== value) {
            // Force update loading state when inventory check completes
            setTimeout(() => updateHubColorLoadingState(), 0);
          }
        },
      });

      // Add watchers for relevant properties
      [
        "isFetchingProducts",
        "loading",
        "fetchingHubInventory",
        "hasCompletedInventoryCheck",
      ].forEach((prop) => {
        store.$watch(prop, () => {
          setTimeout(() => updateHubColorLoadingState(), 0);
        });
      });

      // Watch for product changes
      store.$watch(
        "products",
        () => {
          // Always show loading state when products change
          updateHubColorLoadingState(true);
          // Then check again after a delay
          setTimeout(() => updateHubColorLoadingState(), 500);
        },
        { deep: true }
      );

      // Ensure loading state is shown immediately
      updateHubColorLoadingState(true);
    }

    // Also monitor Alpine changes at a global level
    if (window.Alpine.effect) {
      window.Alpine.effect(() => {
        const store = window.Alpine.store("wheelBuilderForm");
        if (
          store &&
          (store.isFetchingProducts ||
            store.loading ||
            store.fetchingHubInventory)
        ) {
          // When any loading state is detected, show loading indicators
          updateHubColorLoadingState(true);
        }
      });
    }
  }
});
